import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { GET_GUARDIAN_STUDENT_POSTS, GET_GUARDIAN_SECTION_POSTS, GET_GUARDIAN_STUDENT_POST, CLEAR_GUARDIAN_STUDENT_POSTS } from 'actions/posts';
var INITIAL_STATE = {
  posts: [],
  sectionPosts: [],
  post: null
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case GET_GUARDIAN_STUDENT_POSTS:
      var combinedPosts = state.posts;
      if (action.payload != null && action.payload.length > 0) {
        action.payload.forEach(function (d) {
          var checkExisting = combinedPosts.find(function (cb) {
            return cb.id == d.id;
          });
          if (checkExisting == null) {
            combinedPosts.push(d);
          }
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          posts: combinedPosts
        });
      }
      return state;
    case GET_GUARDIAN_SECTION_POSTS:
      if (action.payload != null && action.payload.length > 0) {
        var sectionCombined = state.sectionPosts;
        action.payload.forEach(function (d) {
          var checkExisting = sectionCombined.find(function (cb) {
            return cb.id == d.id;
          });
          if (checkExisting == null) {
            sectionCombined.push(d);
          }
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          sectionPosts: sectionCombined
        });
      }
      return state;
    case GET_GUARDIAN_STUDENT_POST:
      if (action.error) {
        return state;
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        post: action.payload
      });
    case CLEAR_GUARDIAN_STUDENT_POSTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        posts: [],
        sectionPosts: [],
        post: null
      });
    default:
      return state;
  }
}